import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';

export default function CategoryNav() {
  return (
    <section className="py-8 md:py-10">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative overflow-hidden rounded-lg bg-background-100 hover:bg-background-200/70 transition-all p-5 md:p-6 flex flex-col items-center text-center gap-3 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-lg bg-primary-500/10 group-hover:bg-primary-500/20 transition-colors">
                <i className={`${cat.icon} text-xl md:text-2xl text-primary-500`}></i>
              </div>
              <div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 group-hover:text-primary-500 transition-colors">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-500 mt-1 line-clamp-2">
                  {cat.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}